import { alertWithMessage } from "components/modal/message_modal";
import { getCookie } from "cookies-next";
import Router from "next/router";
import client, { prefix } from "../client";

export interface StartGameWithAutoRegisterRequest {
  Device?: string | undefined;
}

export interface StartGameWithAutoRegisterResponse {
  status?: "success" | "error";
  message?: string;
  data?: {
    game_url?: string;
    auto_registered?: boolean;
    ufabet_username?: string;
    ufabet_password?: string;
  };
}

export default async function API(
  request: StartGameWithAutoRegisterRequest
): Promise<StartGameWithAutoRegisterResponse | undefined> {
  try {
    var windowReference: any;

    if (!window.navigator.userAgent.includes("Line")) {
      windowReference = window.open();
    }

    const response = await client.post<StartGameWithAutoRegisterResponse>(
      "/ufabet/start-game-auto-register",
      {
        device: request.Device,
        prefix: prefix,
        access_token: getCookie("access_token")?.toString(),
        token: getCookie("refresh_token")?.toString(),
      }
    );

    const json = response.data;

    if (json.status === "success" && json.data?.game_url) {
      if (windowReference != null) {
        windowReference.location = json.data.game_url;
      } else {
        Router.push(json.data.game_url);
      }
      return json;
    } else {
      alertWithMessage(
        json.message || "ไม่สามารถเริ่มเล่นเกมได้ กรุณาลองใหม่อีกครั้ง"
      );
      if (windowReference != null) {
        windowReference.close();
      } else {
        Router.back();
      }
      return undefined;
    }
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
    alertWithMessage(errorMessage);

    if (typeof windowReference !== "undefined" && windowReference != null) {
      windowReference.close();
    } else {
      Router.back();
    }
    return undefined;
  }
}
